//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file dxos/mesh/muxer.proto.
 */
export const file_dxos_mesh_muxer = /*@__PURE__*/ fileDesc("ChVkeG9zL21lc2gvbXV4ZXIucHJvdG8SD2R4b3MubWVzaC5tdXhlciLHAQoHQ29tbWFuZBI0CgxvcGVuX2NoYW5uZWwYASABKAsyHC5keG9zLm1lc2gubXV4ZXIuT3BlbkNoYW5uZWxIABIlCgRkYXRhGAIgASgLMhUuZHhvcy5tZXNoLm11eGVyLkRhdGFIABIrCgdkZXN0cm95GAMgASgLMhguZHhvcy5tZXNoLm11eGVyLkRlc3Ryb3lIABInCgVjbG9zZRgEIAEoCzIWLmR4b3MubWVzaC5tdXhlci5DbG9zZUgAQgkKB3BheWxvYWQiUgoLT3BlbkNoYW5uZWwSCgoCaWQYASABKAUSCwoDdGFnGAIgASgJEhkKDGNvbnRlbnRfdHlwZRgDIAEoCUgAiAEBQg8KDV9jb250ZW50X3R5cGUiKAoERGF0YRISCgpjaGFubmVsX2lkGAEgASgFEgwKBGRhdGEYAiABKAwiJwoHRGVzdHJveRISCgVlcnJvchgBIAEoCUgAiAEBQggKBl9lcnJvciIlCgVDbG9zZRISCgVlcnJvchgBIAEoCUgAiAEBQggKBl9lcnJvcmIGcHJvdG8z");
/**
 * Describes the message dxos.mesh.muxer.Command.
 * Use `create(CommandSchema)` to create a new message.
 */
export const CommandSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_muxer, 0);
/**
 * Describes the message dxos.mesh.muxer.OpenChannel.
 * Use `create(OpenChannelSchema)` to create a new message.
 */
export const OpenChannelSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_muxer, 1);
/**
 * Describes the message dxos.mesh.muxer.Data.
 * Use `create(DataSchema)` to create a new message.
 */
export const DataSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_muxer, 2);
/**
 * Describes the message dxos.mesh.muxer.Destroy.
 * Use `create(DestroySchema)` to create a new message.
 */
export const DestroySchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_muxer, 3);
/**
 * Describes the message dxos.mesh.muxer.Close.
 * Use `create(CloseSchema)` to create a new message.
 */
export const CloseSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_muxer, 4);
//# sourceMappingURL=muxer_pb.js.map